"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _variables = require("../../styles/variables");
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _Close = _interopRequireDefault(require("@honeybook/icons/dist/icons/Close16"));
var _Pencil = _interopRequireDefault(require("@honeybook/icons/dist/icons/Pencil16"));
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _HBBaseTag = require("./HBBaseTag.utils");
var _animations = require("../../styles/animations");
var _mixins = require("../../styles/mixins");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBBaseTag = function HBBaseTag(props) {
  var label = props.label,
    size = props.size,
    isSelected = props.isSelected,
    _props$selectable = props.selectable,
    selectable = _props$selectable === void 0 ? false : _props$selectable,
    isSquare = props.isSquare,
    theme = props.theme,
    onClick = props.onClick,
    onEdit = props.onEdit,
    onRemove = props.onRemove,
    padding = props.padding,
    PrefixIcon = props.prefixIcon;
  var isClickable = !!onClick;
  var isEditable = !!onEdit;
  (0, _HBBaseTag.assertCorrectPrefixIconSizeInDev)({
    prefixIcon: PrefixIcon,
    size: size
  });
  return /*#__PURE__*/_react["default"].createElement(HBBaseTagWrapper, {
    $clickable: isClickable,
    $editable: isEditable,
    $size: size,
    $isSquare: isSquare,
    $isSelected: isSelected,
    $selectable: selectable,
    $theme: theme,
    $padding: padding,
    onClick: isEditable ? undefined : onClick || isClickable && function () {}
    // Keeps it so that only the edit button is focusable, yet hover is still visible (no pointer-events: none)
    ,
    tabIndex: isEditable ? -1 : undefined
  }, PrefixIcon && /*#__PURE__*/_react["default"].createElement(PrefixIconWrapper, {
    $iconColor: theme.iconColor,
    $size: size
  }, /*#__PURE__*/_react["default"].createElement(PrefixIcon, null)), /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: STRUCTURE[size].textType,
    color: theme.labelColor
  }, label), onEdit && /*#__PURE__*/_react["default"].createElement(EditButton, {
    "aria-label": "Edit button",
    onClick: onEdit,
    $size: size,
    $theme: theme,
    $isSquare: isSquare
  }, /*#__PURE__*/_react["default"].createElement(_Pencil["default"], {
    color: _colors["default"][theme.editIconColor]
  })), onRemove && /*#__PURE__*/_react["default"].createElement(RemoveButton, {
    "aria-label": "Remove button",
    onClick: onRemove,
    role: "button",
    $isSquare: isSquare
  }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    color: _colors["default"][theme.removeIconColor],
    svgProps: {
      width: 12,
      height: 12
    }
  })));
};
var _default = exports["default"] = HBBaseTag;
var STRUCTURE = {
  sm: {
    height: _spacing["default"][24],
    minWidth: _spacing["default"][32],
    textType: 'body14',
    editButtonRight: _spacing["default"][2],
    iconLineHeight: _spacing["default"][12]
  },
  md: {
    height: _spacing["default"][32],
    minWidth: _spacing["default"][32],
    textType: 'body16',
    editButtonRight: _spacing["default"][8],
    iconLineHeight: _spacing["default"][16]
  }
};
var getEditButtonHoverAndFocusStyles = function getEditButtonHoverAndFocusStyles(color) {
  return (0, _styledComponents.css)(["display:flex;justify-content:center;align-items:center;", ""], color && (0, _styledComponents.css)(["background:linear-gradient( to right,transparent 0%,", " 25%,", " 100% );"], color, color));
};
var HBBaseTagWrapper = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBBaseTag__HBBaseTagWrapper",
  componentId: "sc-hm6pel-0"
})(["display:inline-flex;gap:", ";align-items:center;justify-content:center;height:", ";", " border-radius:", ";background-color:", ";position:relative;overflow:hidden;", " ", " ", " ", " ", " &:hover{", " ", " ", "}"], _spacing["default"][4], function (_ref) {
  var $size = _ref.$size;
  return STRUCTURE[$size || 'sm'].height;
}, function (_ref2) {
  var $padding = _ref2.$padding;
  return $padding && "padding: ".concat($padding, ";");
}, function (_ref3) {
  var $isSquare = _ref3.$isSquare;
  return $isSquare ? '4px' : _variables.cornerRadiusRound;
}, function (_ref4) {
  var $theme = _ref4.$theme;
  return $theme.backgroundColor;
}, (0, _animations.transition)('background-color'), (0, _animations.transition)('background-image'), function (_ref5) {
  var $selectable = _ref5.$selectable;
  return $selectable && "border: 1px solid;";
}, function (_ref6) {
  var $selectable = _ref6.$selectable,
    $theme = _ref6.$theme;
  return $selectable && "border-color: ".concat($theme.borderColor, ";");
}, function (_ref7) {
  var $selectable = _ref7.$selectable,
    $isSelected = _ref7.$isSelected;
  return $selectable && "border-width: ".concat($isSelected ? 2 : 1, "px;");
}, function (_ref8) {
  var $clickable = _ref8.$clickable,
    $theme = _ref8.$theme,
    $isSelected = _ref8.$isSelected,
    $selectable = _ref8.$selectable;
  return $clickable && !$isSelected && !$selectable && (0, _styledComponents.css)(["&::after{content:'';position:absolute;inset:0;background-color:", ";pointer-events:none;}"], $theme.hoverBackgroundColor);
}, function (_ref9) {
  var $selectable = _ref9.$selectable,
    $theme = _ref9.$theme;
  return $selectable && (0, _styledComponents.css)(["border-color:", ";"], $theme.hoverBorderColor);
}, function (_ref0) {
  var $clickable = _ref0.$clickable,
    $theme = _ref0.$theme,
    $isSelected = _ref0.$isSelected;
  return $clickable && $isSelected && (0, _styledComponents.css)(["background-color:", ";"], $theme.hoverBackgroundColor);
});
var EditButton = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBBaseTag__EditButton",
  componentId: "sc-hm6pel-1"
})(["padding:0;position:absolute;right:", ";top:50%;transform:translateY(-50%);display:flex;opacity:0;", " ", " border-radius:", ";", ":hover &{opacity:1;}&:focus-visible{opacity:1;}", " i{display:flex;}"], function (_ref1) {
  var $size = _ref1.$size;
  return STRUCTURE[$size].editButtonRight;
}, function (_ref10) {
  var $size = _ref10.$size;
  return $size === 'sm' && 'height: 18px; width: 18px;';
}, function (_ref11) {
  var $size = _ref11.$size;
  return $size === 'md' && 'height: 22px; width: 22px;';
}, function (_ref12) {
  var $isSquare = _ref12.$isSquare;
  return $isSquare ? '4px' : _variables.cornerRadiusRound;
}, HBBaseTagWrapper, function (_ref13) {
  var $theme = _ref13.$theme;
  return getEditButtonHoverAndFocusStyles($theme.backgroundColor);
});
var RemoveButton = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBBaseTag__RemoveButton",
  componentId: "sc-hm6pel-2"
})(["display:flex;align-items:center;justify-content:center;height:15px;width:15px;border-radius:", ";i{display:flex;}", ":hover &{display:flex;}"], function (_ref14) {
  var $isSquare = _ref14.$isSquare;
  return $isSquare ? '4px' : _variables.cornerRadiusRound;
}, HBBaseTagWrapper);
var PrefixIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBBaseTag__PrefixIconWrapper",
  componentId: "sc-hm6pel-3"
})(["display:flex;align-items:center;height:100%;", " i{display:flex;align-items:center;line-height:", ";}"], function (_ref15) {
  var $iconColor = _ref15.$iconColor;
  return (0, _mixins.setIconFillColor)($iconColor);
}, function (_ref16) {
  var $size = _ref16.$size;
  return STRUCTURE[$size].iconLineHeight;
});
//# sourceMappingURL=HBBaseTag.js.map